import React, { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock
} from 'react-icons/fa';
import { FaFacebook, FaYoutube } from 'react-icons/fa';
import '../Style/ContactUs.css';

gsap.registerPlugin(ScrollTrigger);

const WHATSAPP_NUMBER = '923114259629';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState('');
  const sectionRef = useRef(null);
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        titleRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      gsap.fromTo(
        leftRef.current,
        { x: -50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: 0.2,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );

      gsap.fromTo(
        rightRef.current,
        { x: 50, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: 0.4,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('');

    const whatsappMessage = `
Hello Automotive Devices,

I want to contact you.

Name: ${formData.name}
Phone: ${formData.phone}
Email: ${formData.email}
Message: ${formData.message}
`;

    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      whatsappMessage
    )}`;

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');

    setStatus('Opening WhatsApp...');
    setFormData({ name: '', phone: '', email: '', message: '' });
  };

  return (
    <div ref={sectionRef}>
      <h1 className="just" ref={titleRef}>Contact Us</h1>

      <img src="/buzz.png" alt="Contact Us" className="contact-img" />

      <div className="container contact-main">
        <div className="contact-left" ref={leftRef}>
          <p className="contact-small-text">Let's get in touch.</p>
          <h2 className="contact-title">GET IN TOUCH</h2>

          <p className="contact-description">
            Ready to elevate your project? Reach out to us! Our team is eager to discuss your specific
            needs and explore how our tailored solutions can bring your ideas to life. Contact us today to
            start your journey towards innovative and efficient results.
          </p>

          <div className="contact-line"></div>

          <div className="contact-info">
            <div className="info-item">
              <span className="icon-wrapper">
                <FaEnvelope className="info-icon" />
              </span>
              <div>
                <strong>EMAIL</strong>
                <div>ali@automotivedevices.com</div>
              </div>
            </div>

            <div className="info-item">
              <span className="icon-wrapper">
                <FaMapMarkerAlt className="info-icon" />
              </span>
              <div>
                <strong>LOCATION</strong>
                <div>Plot No. 66C to 68C</div>
              </div>
            </div>

            <div className="info-item">
              <span className="icon-wrapper">
                <FaClock className="info-icon" />
              </span>
              <div>
                <strong>OPENING HOURS</strong>
                <div>24/7</div>
              </div>
            </div>
          </div>

          <div className="contact-line"></div>

          <div className="contact-icons">
            <div className="txt">Social Media</div>

            <div className="social-container">
              <a
                href="https://www.facebook.com/automotivedevices/videos?ref=page_internal"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link facebook"
              >
                <FaFacebook className="icon-inner" />
              </a>

              <a
                href="https://www.youtube.com/watch?v=EGcS9MmdnZU"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link youtube"
              >
                <FaYoutube className="icon-inner" />
              </a>
            </div>
          </div>
        </div>

        <div className="contact-right" ref={rightRef}>
          <h2 className="message-title">LEAVE A MESSAGE</h2>
          <p className="message-subtext">And we will get back to you shortly</p>

          <form className="message-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="NAME"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="phone"
              placeholder="PHONE NUMBER"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="EMAIL"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="YOUR MESSAGES"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
            />

            <button type="submit">SEND MESSAGE</button>
          </form>

          {status && (
            <p style={{ marginTop: '10px', color: 'green' }}>
              {status}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;